export const log = (text: string, params: any = null) => {
  console.info(`%c[HOMEPAGE] %c${text}`, 'color: green; font-weight: bold', '', params)
}
